module.exports = __webpack_public_path__ + "352c6398b4f67d95860dae8f84b8e299.MP3";